@if (isFetching) {
  <div class="section-priorities-card">
    <div>
      <ngx-skeleton-loader></ngx-skeleton-loader>
      <div class="current-tickets">
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '40px',
            height: '40px',
            'border-radius': '10px',
            margin: '0 auto',
            background: 'var(--skeleton-background)',
          }"
        ></ngx-skeleton-loader>
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            width: '72px',
            height: '27px',
            'border-radius': '10px',
            margin: '10px auto 0',
            background: 'var(--skeleton-background)',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
    <div>
      <p class="title">
        <ngx-skeleton-loader
          [theme]="{ width: '100px', background: 'var(--skeleton-background)' }"
        ></ngx-skeleton-loader>
      </p>
      <div class="d-flex">
        @for (i of [1, 2, 3, 4, 5]; track i) {
          <ngx-skeleton-loader
            count="1"
            [theme]="{
              width: '80px',
              height: '92px',
              'border-radius': '20px',
              margin: '0 4px',
              background: 'var(--skeleton-background)',
            }"
          ></ngx-skeleton-loader>
        }
      </div>
    </div>
  </div>
}
@if (!isFetching && errorFetching) {
  <div class="section-error">
    <mat-icon>error_outline</mat-icon>
    <span>Failed to load priorities</span>
    <button class="retry-button" (click)="retry()">Retry</button>
  </div>
}
@if (!isFetching && !errorFetching) {
  <mat-card class="section-priorities-card">
    <div>
      <p class="title">Current Tickets</p>
      <div
        class="current-tickets"
        [class.has-items]="currentTickets > 0"
        (click)="currentTickets > 0 ? filterByCurrentTickets() : null"
      >
        <span>{{ currentTickets }}</span>
        <div class="priorities-chart">
          <canvas baseChart [data]="barChartData" [options]="barChartOptions" [type]="'bar'"> </canvas>
        </div>
      </div>
    </div>
    <div>
      <p class="title">By Priority</p>
      <div class="d-flex">
        @for (priority of priorities; track priority.id) {
          <div
            class="priority mx-1"
            [class.has-items]="priority.count > 0"
            (click)="priority.count > 0 ? filterByPriority(priority) : null"
          >
            <span class="priority-count">{{ priority.count }}</span>
            <span class="priority-label" [ngClass]="priority.label.toLowerCase()">{{ priority.label }}</span>
          </div>
        }
      </div>
    </div>
  </mat-card>
}
